import { render, staticRenderFns } from "./DetailResourceMaster.vue?vue&type=template&id=6fa308b7&scoped=true"
import script from "./DetailResourceMaster.vue?vue&type=script&lang=js"
export * from "./DetailResourceMaster.vue?vue&type=script&lang=js"
import style0 from "./DetailResourceMaster.vue?vue&type=style&index=0&id=6fa308b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa308b7",
  null
  
)

export default component.exports